import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { BASE_URL } from "../CommonApi";
import { AES, enc } from "crypto-js";

const EmployeeAccess = ({ id, onCancel }) => {
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const jwtToken = localStorage.getItem("jwtToken");

  // Employee basic info state
  const [employeeInfo, setEmployeeInfo] = useState({
    name: "",
    department: "",
    designation: "",
    employeeId: id,
    empId: "",
  });

  const [accessRecordId, setAccessRecordId] = useState("");

  const [accessOptions, setAccessOptions] = useState([
    { name: "Dashboard", checked: false, apiKey: "dashboard" },
    { name: "Items", checked: false, apiKey: "items" },
    { name: "Enquiry", checked: false, apiKey: "enquiry" },
    { name: "Banking", checked: false, apiKey: "banking" },
    { name: "Sales", checked: false, apiKey: "sales" },
    { name: "Customers", checked: false, apiKey: "customer" },
    { name: "Estimates", checked: false, apiKey: "estimates" },
    { name: "Sales Orders", checked: false, apiKey: "salesOrders" },
    { name: "Delivery Challans", checked: false, apiKey: "deliveryChallans" },
    { name: "Invoice", checked: false, apiKey: "invoice" },
    { name: "Pro Forma", checked: false, apiKey: "proFroma" },
    { name: "Recurring Invoice", checked: false, apiKey: "recurringInvoice" },
    { name: "Payment Received", checked: false, apiKey: "paymentReceived" },
    { name: "Credit Notes", checked: false, apiKey: "creditNotes" },
    { name: "Quotation", checked: false, apiKey: "quotation" },
    { name: "Purchase", checked: false, apiKey: "purchase" },
    { name: "Vendors", checked: false, apiKey: "vendors" },
    { name: "Expenses", checked: false, apiKey: "expenses" },
    { name: "Bills", checked: false, apiKey: "bills" },
    { name: "Purchase Order", checked: false, apiKey: "purchaseOrder" },
    { name: "Payments Made", checked: false, apiKey: "paymentsMade" },
    { name: "HR", checked: false, apiKey: "hr" },
    { name: "HRS Employee", checked: false, apiKey: "hrsEmployee" },
    { name: "HRS Candidate", checked: false, apiKey: "hrsCandidate" },
    { name: "Time Sheet", checked: false, apiKey: "timeSheet" },
    { name: "CRM", checked: false, apiKey: "crm" },
    { name: "Campaign", checked: false, apiKey: "campaign" },
    { name: "Cheque", checked: false, apiKey: "cheque" },
    { name: "Password Manager", checked: false, apiKey: "passwordManager" },
    { name: "Appointments", checked: false, apiKey: "appointments" },
    { name: "Indent", checked: false, apiKey: "indent" },
    { name: "Inward", checked: false, apiKey: "inword" },
    { name: "Outward", checked: false, apiKey: "outword" },
    { name: "Documents", checked: false, apiKey: "documents" },
    { name: "User And Roles", checked: false, apiKey: "userAndRoles" },
    { name: "Users", checked: false, apiKey: "users" },
    { name: "Manage SalesPerson", checked: false, apiKey: "manageSalesPerson" },
    { name: "Reports", checked: false, apiKey: "reports" },
  ]);

  const [hasCheckedAccess, setHasCheckedAccess] = useState(false);

  const fetchEmployeeData = async () => {
    try {
      // Fetch basic employee info
      const infoResponse = await fetch(`${BASE_URL}/getHrsDataById`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify({ id: String(id) }),
      });

      const infoData = await infoResponse.json();
      if (infoResponse.ok) {
        const employeeData = infoData.data;
        setEmployeeInfo({
          name: employeeData.name,
          department: employeeData.department,
          designation: employeeData.designation,
          employeeId: id,
          empId: employeeData.employeId,
        });
      }

      // First try to fetch existing access rights
      try {
        const accessResponse = await fetch(
          `https://trading.zarpsoftware.in/jps/JpserpApi/getEmpMenuByEmpId`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({
              emp_id: id,
              uniqueId: decryptedUniqueId,
            }),
          }
        );

        const accessData = await accessResponse.json();

        if (accessResponse.ok && accessData.status === "success") {
          const accessRights = accessData.message;

          setAccessRecordId(accessRights.id);

          setAccessOptions((prevOptions) =>
            prevOptions.map((option) => ({
              ...option,
              checked: accessRights[option.apiKey] === "1",
            }))
          );
          setHasCheckedAccess(true);
          return;
        }
      } catch (fetchError) {
        console.log("No existing access record found, will create new one");
      }

      // If we get here, it means no access record exists, so create one
      if (!hasCheckedAccess) {
        const createResponse = await fetch(
          `https://trading.zarpsoftware.in/jps/JpserpApi/create_emp_menu`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwtToken}`,
            },
            body: JSON.stringify({
              dashboard: 1,
              items: 1,
              enquiry: 0,
              banking: 0,
              sales: 1,
              customer: 1,
              estimates: 0,
              salesOrders: 0,
              deliveryChallans: 0,
              invoice: 0,
              proFroma: 0,
              recurringInvoice: 0,
              paymentReceived: 0,
              creditNotes: 0,
              quotation: 0,
              purchase: 0,
              vendors: 0,
              expenses: 0,
              bills: 0,
              purchaseOrder: 0,
              paymentsMade: 0,
              hr: 0,
              hrsEmployee: 0,
              hrsCandidate: 0,
              timeSheet: 0,
              crm: 0,
              campaign: 0,
              cheque: 0,
              passwordManager: 0,
              appointments: 0,
              indent: 0,
              inword: 0,
              outword: 0,
              documents: 1,
              userAndRoles: 0,
              users: 0,
              manageSalesPerson: 0,
              reports: 1,
              uniqueId: decryptedUniqueId,
              emp_id: id,
            }),
          }
        );

        const createData = await createResponse.json();

        if (createResponse.ok) {
          // Now fetch the newly created access rights
          const newAccessResponse = await fetch(
            `https://trading.zarpsoftware.in/jps/JpserpApi/getEmpMenuByEmpId`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
              },
              body: JSON.stringify({
                emp_id: id,
                uniqueId: decryptedUniqueId,
              }),
            }
          );

          const newAccessData = await newAccessResponse.json();

          if (newAccessResponse.ok && newAccessData.status === "success") {
            const accessRights = newAccessData.message;

            setAccessOptions((prevOptions) =>
              prevOptions.map((option) => ({
                ...option,
                checked: accessRights[option.apiKey] === "1",
              }))
            );
          }
        }
        setHasCheckedAccess(true);
      }
    } catch (error) {
      console.error("Error in employee access workflow:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, [id, jwtToken, decryptedUniqueId, hasCheckedAccess]);

  const handleCancelClick = () => {
    onCancel();
  };

  const handleCheckboxChange = (index) => {
    const newAccessOptions = [...accessOptions];
    newAccessOptions[index].checked = !newAccessOptions[index].checked;
    setAccessOptions(newAccessOptions);

    console.log(
      `Access ${newAccessOptions[index].name} changed to ${newAccessOptions[index].checked}`
    );
  };

  // Split options into two columns
  const midPoint = Math.ceil(accessOptions.length / 2);
  const firstColumn = accessOptions.slice(0, midPoint);
  const secondColumn = accessOptions.slice(midPoint);

  const handleSaveChanges = async () => {
    try {
      // Prepare the request body by converting checked status to 1/0
      const requestBody = {
        emp_id: id,
        uniqueId: decryptedUniqueId,
      };

      // Add all access options to the request body
      accessOptions.forEach((option) => {
        requestBody[option.apiKey] = option.checked ? 1 : 0;
      });

      // Make the API call to update access rights
      const updateResponse = await fetch(
        `https://trading.zarpsoftware.in/jps/JpserpApi/update_emp_menu/${accessRecordId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const updateData = await updateResponse.json();

      if (updateResponse.ok && updateData.status === "success") {
        alert("Access rights updated successfully!");
        await fetchEmployeeData();
        // You might want to refresh the data or perform other actions here
      } else {
        alert(
          "Failed to update access rights: " +
            (updateData.message || "Unknown error")
        );
      }
    } catch (error) {
      console.error("Error updating access rights:", error);
      alert("An error occurred while updating access rights");
    }
  };

  return (
    <Container fluid className="py-4">
      <Row>
        <Col>
          <div className="my-3">
            <div className="px-2 d-flex">
              <div className="cursor-pointer d-flex justify-content-center align-items-center back-button">
                <ArrowBackIosIcon
                  width={2}
                  className="arrow-child"
                  onClick={handleCancelClick}
                />
              </div>
              <h5
                className="mt-1 mx-2 text-primary"
                style={{ letterSpacing: "1px" }}
              >
                Employee Access Rights
              </h5>
            </div>
          </div>

          <Card className="shadow-sm card-style">
            <Card.Body>
              {/* Employee Basic Info Section */}
              <Row className="mb-4">
                <Col>
                  <Card className="bg-light">
                    <Card.Body>
                      <Row>
                        <Col md={4}>
                          <p className="mb-2">
                            <strong>Employee ID:</strong>{" "}
                            {employeeInfo.employeeId}
                          </p>
                        </Col>
                        <Col md={4}>
                          <p className="mb-2">
                            <strong>Name:</strong> {employeeInfo.name}
                          </p>
                        </Col>
                        <Col md={4}>
                          <p className="mb-2">
                            <strong>Department:</strong>{" "}
                            {employeeInfo.department}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <p className="mb-2">
                            <strong>Designation:</strong>{" "}
                            {employeeInfo.designation}
                          </p>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Access Rights Section */}
              <Row>
                <Col>
                  <Card>
                    <Card.Body>
                      <h5 className="text-primary mb-4">Access Rights</h5>
                      <Row>
                        {/* First Column of Options */}
                        <Col md={6}>
                          {firstColumn.map((option, index) => (
                            <Form.Group
                              key={index}
                              className="mb-3"
                              controlId={`formBasicCheckbox${index}`}
                            >
                              <Form.Check
                                type="checkbox"
                                label={option.name}
                                checked={option.checked}
                                onChange={() => handleCheckboxChange(index)}
                              />
                            </Form.Group>
                          ))}
                        </Col>

                        {/* Second Column of Options */}
                        <Col md={6}>
                          {secondColumn.map((option, index) => (
                            <Form.Group
                              key={index + midPoint}
                              className="mb-3"
                              controlId={`formBasicCheckbox${index + midPoint}`}
                            >
                              <Form.Check
                                type="checkbox"
                                label={option.name}
                                checked={option.checked}
                                onChange={() =>
                                  handleCheckboxChange(index + midPoint)
                                }
                              />
                            </Form.Group>
                          ))}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Action Buttons */}
              <Row className="mt-4">
                <Col className="d-flex justify-content-end">
                  <Button
                    variant="secondary"
                    onClick={handleCancelClick}
                    className="me-2"
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleSaveChanges}>
                    Save Changes
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeAccess;
